export default "__VITE_ASSET__B$0B6d$8__"